"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Disclaimers_1 = __importDefault(require("./Disclaimers"));

exports.default = Disclaimers_1.default;